import classNames from 'classnames'

import ProductDetails from './ProductDetails'
import styles from './ProductTour.module.scss'

function ProductTour({ widgetDetails: productTourData }) {
  const { title: heading, tabs = [] } = productTourData

  return (
    tabs?.length > 0 &&
    tabs[0]?.cards &&
    tabs[0]?.cards.length > 0 && (
      <div className={styles.container}>
        <div className={classNames('page-container', styles.headerSection)}>
          <h1 className={styles.heading}>{heading}</h1>
          {/* <div className={classNames(styles.tabsContainer)}>
          {tabs?.map((product, index) => {
            return (
              <TabButton
                key={'tab' + index}
                id={product.id}
                selected={selectedTab.id}
                label={product.title}
                type={'button'}
                handleClick={(id) => handleTabSelection(product)}
                isScrollable={false}
                buttonClass={styles.tabButton}
              />
            )
          })}
        </div> */}
        </div>
        <ProductDetails details={tabs[0]} />
      </div>
    )
  )
}

export default ProductTour
